var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCard',[_c('CCardBody',[_c('ListTable',{attrs:{"loading":_vm.loading,"items":_vm.items,"fields":_vm.fields,"showPagination":false},on:{"row-clicked":_vm.handleRowClick}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }